(() => {
  const init = (root = document) => root.querySelectorAll('[data-bb-video-hero]').forEach(section => {
    if (section.dataset.videoReady) return;
    section.dataset.videoReady = 'true';
    const video = section.querySelector('video'), button = section.querySelector('button');
    const sync = () => { button.textContent = video.paused ? '▶' : 'Ⅱ'; button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); };
    button.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
    video.addEventListener('play', sync); video.addEventListener('pause', sync);
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(sync);
    sync();
  });
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
